import { render, staticRenderFns } from "./SubsidyStandardSetting.vue?vue&type=template&id=4e744e70&scoped=true"
import script from "./SubsidyStandardSetting.vue?vue&type=script&lang=js"
export * from "./SubsidyStandardSetting.vue?vue&type=script&lang=js"
import style0 from "./SubsidyStandardSetting.vue?vue&type=style&index=0&id=4e744e70&prod&lang=less&scoped=true"
import style1 from "./SubsidyStandardSetting.vue?vue&type=style&index=1&id=4e744e70&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e744e70",
  null
  
)

export default component.exports